// Persistence for the soft-auth token. Stored in both localStorage and a
// long-lived cookie so a user clearing one doesn't necessarily lose the other.
// localStorage is the source of truth on read; cookie is a backup.

const STORAGE_KEY = 'games:softAuthToken';
const COOKIE_KEY = 'fb_token';
const COOKIE_TEN_YEARS = 60 * 60 * 24 * 365 * 10;

function readCookie(name: string): string | null {
  const c = (typeof document !== 'undefined' && document.cookie) || '';
  for (const part of c.split(';')) {
    const [k, ...rest] = part.trim().split('=');
    if (k === name) return decodeURIComponent(rest.join('='));
  }
  return null;
}

function writeCookie(name: string, value: string): void {
  if (typeof document === 'undefined') return;
  const isHttps = location.protocol === 'https:';
  const attrs = [
    `${name}=${encodeURIComponent(value)}`,
    `Max-Age=${COOKIE_TEN_YEARS}`,
    'Path=/',
    'SameSite=Lax',
  ];
  if (isHttps) attrs.push('Secure');
  document.cookie = attrs.join('; ');
}

function clearCookie(name: string): void {
  if (typeof document === 'undefined') return;
  document.cookie = `${name}=; Max-Age=0; Path=/; SameSite=Lax`;
}

export function loadToken(): string | null {
  let t: string | null = null;
  try {
    t = localStorage.getItem(STORAGE_KEY);
  } catch {}
  if (!t) t = readCookie(COOKIE_KEY);
  if (t && t.length >= 8 && t.length <= 256) return t;
  return null;
}

export function saveToken(token: string): void {
  try {
    localStorage.setItem(STORAGE_KEY, token);
  } catch {}
  writeCookie(COOKIE_KEY, token);
}

export function clearToken(): void {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {}
  clearCookie(COOKIE_KEY);
}

const LAST_SEEN_LEVEL_KEY = 'games:lastSeenLevel';

export function getLastSeenLevel(): number {
  try {
    const raw = localStorage.getItem(LAST_SEEN_LEVEL_KEY);
    const n = raw ? Number.parseInt(raw, 10) : NaN;
    return Number.isFinite(n) && n > 0 ? n : 0;
  } catch {
    return 0;
  }
}

export function setLastSeenLevel(level: number): void {
  try {
    localStorage.setItem(LAST_SEEN_LEVEL_KEY, String(level));
  } catch {}
}
